import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import project1 from "../img/Project1.png";
import project2 from "../img/Project2.png";
import project3 from "../img/Project3.png";
import "../css/home.css";

function Projects() {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('show');
          }
        });
      },
      { threshold: 0.3 }
    );

    const elements = document.querySelectorAll('.fade-up');
    elements.forEach(el => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  const projectData = [
    {
      img: project1,
      title: "NestShine",
      desc: "Complete home deep cleaning for a spotless living space.",
    },
    {
      img: project2,
      title: "ShinyHome",
      desc: "Kitchen cleaning with hygiene and shine guaranteed.",
    },
    {
      img: project3,
      title: "BrightNest",
      desc: "Bathroom sanitization and sparkling finish every time.",
    },
  ];

  return (
    <section className="projects-section py-5">
      <div className="container">
        {/* Section Heading */}
        <div className="text-center mb-5 fade-up">
          <h6 className="section-tag">OUR WORK</h6>
          <hr className="center-hr " />
          <h2 className="section-title">Recent Projects</h2>
          <p className="section-desc">
            Check out some of the professional cleaning projects we’ve completed
            for our clients.
          </p>
        </div>

        {/* Projects Cards */}
        <div className="row">
          {projectData.map((project, index) => (
            <div className="col-md-4 mb-4 fade-up" key={index}>
              <div className="project-card h-100 text-center">
                <img
                  src={project.img}
                  alt={project.title}
                  className="img-fluid project-img"
                />
                <div className="project-content p-3">
                  <h5 className="project-title">{project.title}</h5>
                  <p className="project-desc">{project.desc}</p>
                  <Link to="/projects" className="project-btn d-inline-flex align-items-center gap-2">View Project</Link>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* See All Projects Button */}
        <div className="text-center mt-4 fade-up">
          <Link to="/projects" className="btn btn-all-projects btn-lg">
            See All Projects
          </Link>
        </div>
      </div>
    </section>
  );
}

export default Projects;
